<template>
    <div v-if="value" class="flex items-center gap-0.5 text-primary">
        <template v-for="star in value" :key="star">
            <i class="icon-star text-sm" />
        </template>
    </div>
</template>

<script setup>
const props = defineProps({
    value: {
        type: Number,
        default: null
    }
})
</script>
